import { useEffect, useState } from 'react'

import Api from 'services/api'

const useRemoteConfigCompatible = (deviceId: string, connected: boolean) => {
  const [compatible, setCompatible] = useState(false)

  useEffect(() => {
    setCompatible(false)

    if (connected) {
      Api.RemoteConfig.compatible(deviceId)
        .then((res) => {
          setCompatible(res.compatible)
        }).catch(() => {
          setCompatible(false)
        })
    }
  }, [deviceId, connected])

  return { compatible }
}

export default useRemoteConfigCompatible
